import React from 'react'

const Button = ({className, children}) => {
    return (<button
            className={`${className} bg-prime flex items-center justify-center text-white p-4 rounded hover:bg-indigo-400 duration-500`}>
            <div className="my-0 mx-2">
                {children}
            </div>
        </button>)
}

export default Button
